import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "ReparticionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "ReparticionPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexReparticion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Num', name: 'Num', title: 'Num' },
                { data: 'Codigo', name: 'Codigo', title: 'Codigo' },
                { data: 'UnidadSuperior', name: 'UnidadSuperior', title: 'Unidad Sup.' },
                { data: 'Reparticion', name: 'Reparticion', title: 'Repartición' },
                { data: 'CodigoGuarnicion', name: 'CodigoGuarnicion', title: 'Codigo Guarnición' },
                { data: 'Frontera', name: 'Frontera', title: 'Frontera' },
                { data: 'CodigoLugar', name: 'CodigoLugar', title: 'Codigo Lugar' },
                { data: 'CodigoPpto', name: 'CodigoPpto', title: 'Codigo Ppto' },
                { data: 'Sigla', name: 'Sigla', title: 'Sigla' },
                { data: 'Activo', name: 'Activo', title: 'Activo',searchable: false, width: '10%',
                className: 'centradito',
                render: function (data, type, row) {
                if (row.Activo == false) {
                    return '<i class="fa fa-ban text-danger"> Inactivo</i>';
                } else {
                    return '<i class="fa fa-check text-success"> Activo</i>';
                }
                },
            },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            unidadAcademicas: [],
            rols: [],
            reparticions: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            reparticion: {},
            
        };
    },
    methods: {
    
        newReparticion() {
            this.reparticion = {};
            this.$refs['frm-reparticion'].show();
            // console.log("hhhhola")
        },
        showReparticion(id) {
            this.isLoading=true;
            this.ss.showReparticion(id).then(
                (result) => {
                    let response = result.data;
                    this.reparticion = response.data;
                    this.$refs['view-reparticion'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editReparticion() {
            this.$refs['frm-reparticion'].show();
            this.$refs['view-reparticion'].hide();
        },
        cancelReparticion() {
            if (this.reparticion.id) {
                this.$refs['view-reparticion'].show();
            }
            this.$refs['frm-reparticion'].hide();
        },
        saveReparticion() {
            this.ss.storeReparticion(this.reparticion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-reparticion'].hide();
                    this.$refs['datatable-reparticion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteReparticion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyReparticion(this.reparticion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-reparticion'].hide();
                                this.$refs['datatable-reparticion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Reparticion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showReparticion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
